<div class="d-flex flex-column w-100">

    <div class="mt-1">
        <div class="links-table container">
            <div>
                <div class="row links-header py-3">
                    <div class="col-md-3">NOME</div>
                    <div class="col-md-3">PREVIEW</div>
                    <div class="col-md-2">STATUS</div>
                    <div class="col-md-4">PUBLICADO</div>
                </div>
                <div cdkDropList (cdkDropListDropped)="drop($event)">
                    <div class="row py-3 link-item" *ngFor="let banner of banners; let index = index" cdkDrag>

                        <div class="col-md-3">
                            <div class="link-item-name">{{banner.name}}</div>
                            <div class="link-item-date">criado em: {{banner.createdAt | date: 'dd/MM/yyyy'}}</div>
                        </div>

                        <div class="col-md-3">
                            <div class="preview-container">
                                <img [src]="banner.imageDesktop" *ngIf="banner.imageDesktop">
                            </div>
                        </div>
                        <div class="col-md-2">
                            <span>{{ getBannerStatus(banner) }}</span><br>
                            <span class="link-item-date" *ngIf="getNextScheduledAction(banner)">
                                Próxima ação: {{ getNextScheduledAction(banner) | date: 'dd/MM/yyyy HH:mm' }}
                            </span>                        
                        </div>

                        <div class="col-md-4">
                            <div class="contenct-published d-flex align-items-center">
                                <div>
                                    <mat-slide-toggle aria-labelledby="slider-label"
                                        [ngModel]="!banner.disabled"
                                        (ngModelChange)="onToggleBanner($event, banner)">
                                    </mat-slide-toggle>
                                </div>
                                <div>
                                    <span class="material-icons" (click)="registerOrUpdate(banner)">edit</span>
                                </div>
                                <div>
                                    <span class="material-icons" (click)="removeBanner(banner)">delete</span>
                                </div>
                                <div cdkDragHandle class="col-drag-indicator link-item-name py-2">
                                    <span class="material-icons">drag_indicator</span>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="mt-5">
        <button type="button" class="btn btn-primary btn-pill confirm-button float-start" (click)="registerOrUpdate()">
            <i class="fa-light fa-plus mr-2"></i>
            Cadastrar novo banner
        </button>
    </div>

    <div class="container mt-5" #registerer *ngIf="registering">
        <span class="label-new-banner">{{banner.id ? 'Atualizar' : 'Cadastrar novo'}} banner</span>
        <div class="row mt-3">
            <div class="col-4 pr-5">
                <mat-form-field>
                    <mat-label>NOME</mat-label>
                    <input matInput class="input-text" [(ngModel)]="banner.name" />
                </mat-form-field>
            </div>
            <div class="col-4 pr-5">
                <mat-form-field>
                    <mat-label>URL DESTINO</mat-label>
                    <input matInput class="input-text" [(ngModel)]="banner.urlDestination" />
                </mat-form-field>
            </div>
            <div class="col-4 pr-5">
                <div class="row-form mb-4">
                    <mat-form-field>
                        <mat-label>Público alvo</mat-label>
                        <mat-select class="input-text" [(ngModel)]="banner.target">
                            <mat-option *ngFor="let target of targetOptions" [value]="target">{{ getTargetLabel(target)
                                }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-12 pr-5">
                <mat-form-field class="w-100">
                    <mat-label>Filtro de compradores</mat-label>
                    <input matInput class="input-text" [(ngModel)]="dealerFilterUrl"/>
                    <mat-hint>Cole a URL da listagem de compradores com os filtros aplicados. Deixe vazio para exibir para todos.</mat-hint>
                </mat-form-field>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-12">    
                <mat-form-field>
                    <mat-label>Tipo de Agendamento</mat-label>
                     <mat-select class="input-text" [(ngModel)]="banner.scheduleType">
                        <mat-option [value]="null">Sem agendamento</mat-option>
                        <mat-option *ngFor="let type of scheduleTypeOptions" [value]="type">
                            {{ scheduleTypeLabels[type]  }}
                        </mat-option>
                     </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="row mt-3" *ngIf="banner.scheduleType === 'ABSOLUTE_DATE'">
            <div class="col-4 pr-5">
                <mat-form-field>
                    <mat-label>DATA DE INÍCIO</mat-label>
                    <input matInput class="input-text" readonly (click)="startDatePicker.open()" 
                        [(ngModel)]="startDateOnly" 
                        (ngModelChange)="onStartDateChange()"
                        [matDatepicker]="startDatePicker" />
                    <span matSuffix>
                        <mat-datepicker-toggle [for]="startDatePicker" class="calendar-icon"></mat-datepicker-toggle>
                    </span>
                    <mat-datepicker #startDatePicker (dateChange)="onStartDateChange()"></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="col-4 pr-5">
                <mat-form-field>
                    <mat-label>DATA DE FINALIZAÇÃO</mat-label>
                    <input matInput class="input-text" readonly (click)="endDatePicker.open()" 
                        [(ngModel)]="endDateOnly" 
                        (ngModelChange)="onEndDateChange()"
                        [matDatepicker]="endDatePicker" />
                    <span matSuffix>
                        <mat-datepicker-toggle [for]="endDatePicker" class="calendar-icon"></mat-datepicker-toggle>
                    </span>
                    <mat-datepicker #endDatePicker (dateChange)="onEndDateChange()"></mat-datepicker>
                </mat-form-field>
            </div>
        </div>
        <div class="row mt-3" *ngIf="banner.scheduleType === 'ABSOLUTE_DATE'">
            <div class="col-4 pr-5">
                <mat-form-field>
                    <mat-label>HORÁRIO DE INÍCIO</mat-label>
                    <input matInput class="input-text" type="text" 
                        [(ngModel)]="startTimeOnly" 
                        (input)="onStartTimeChange()"
                        (blur)="onStartTimeChange()"
                        placeholder="HH:mm"
                        maxlength="5"
                        pattern="^([0-1][0-9]|2[0-3]):[0-5][0-9]$" />
                    <span matSuffix>
                        <mat-icon class="time-icon" style="position: relative; left: -12px;">access_time</mat-icon>
                    </span>
                </mat-form-field>
            </div>
            <div class="col-4 pr-5">
                <mat-form-field>
                    <mat-label>HORÁRIO DE FINALIZAÇÃO</mat-label>
                    <input matInput class="input-text" type="text" 
                        [(ngModel)]="endTimeOnly" 
                        (input)="onEndTimeChange()"
                        (blur)="onEndTimeChange()"
                        placeholder="HH:mm"
                        maxlength="5"
                        pattern="^([0-1][0-9]|2[0-3]):[0-5][0-9]$" />
                    <span matSuffix>
                        <mat-icon class="time-icon" style="position: relative; left: -12px;">access_time</mat-icon>
                    </span>
                </mat-form-field>
            </div>
            <div class="col-12" *ngIf="banner.startDate && banner.endDate && banner.startDate >= banner.endDate">
                <span class="error-message">A data de início deve ser anterior à data de finalização</span>
            </div>
        </div>
        <div class="row mt-3" *ngIf="banner.scheduleType === 'CRON_RECURRENCE'">
            <div class="col-4 pr-5">
                <mat-form-field>
                    <mat-label>Cron Expression - Ativação</mat-label>
                    <input matInput class="input-text" [(ngModel)]="banner.activationCron" 
                        (change)="onCronChange()"
                        placeholder="Ex: 0 10 * * 5" />
                    <mat-hint>Exemplo: 0 10 * * 5 = toda sexta às 10:00</mat-hint>
                </mat-form-field>
                <div *ngIf="cronValidationError && banner.activationCron">
                    <span class="error-message">{{ cronValidationError }}</span>
                </div>
                <div *ngIf="banner.activationCron && !cronValidationError && getNextScheduledAction(banner)" class="cron-next-action mt-2">
                    <span class="link-item-date">Próxima ação: {{ getNextScheduledAction(banner) | date: 'dd/MM/yyyy HH:mm' }}</span>
                </div>
            </div>
            <div class="col-4 pr-5">
                <mat-form-field>
                    <mat-label>Cron Expression - Desativação</mat-label>
                    <input matInput class="input-text" [(ngModel)]="banner.deactivationCron" placeholder="Ex: 0 0 * * 6" />
                    <mat-hint>Exemplo: 0 0 * * 6 = todo sábado à meia-noite</mat-hint>
                </mat-form-field>
                <div *ngIf="cronValidationError && banner.deactivationCron">
                    <span class="error-message">{{ cronValidationError }}</span>
                </div>
            </div>
        </div>
            <div class="row mt-4">
            <div class="col-6 pr-5">
                <div class="container container-white" style="padding: 25px">
                    <div><span class="image-label">IMAGEM PARA DESKTOP</span></div>
                    <div *ngIf="imgUploadMessage" class="file-upload-status"
                        [ngClass]="{'warning-box': imgUploadError, 'success-box': !imgUploadError}">
                        <i class="material-icons" *ngIf="imgUploadError">warning</i>
                        {{imgUploadMessage}}
                    </div>
                    <div *ngIf="imgUploader$ | async as uploader">
                        <div class="ng2FileDrop" ng2FileDrop [uploader]="uploader" *ngIf="!banner.imageDesktop">
                            <i class="material-icons">file_upload</i>
                            <em>Arraste e solte as imagens aqui</em>
                            <span class="btn btn-outline-light">
                                <span>SELECIONAR ARQUIVOS</span>
                                <input type="file" id="imageUrl" ng2FileSelect [uploader]="uploader" multiple />
                            </span>
                            <small class="max-filesize">Tamanho máximo: 4MB</small>
                        </div>

                        <div class="ng2FileDrop container-upload-img" *ngIf="banner.imageDesktop">
                            <span class="material-icons" style="font-size: 24px" (click)="removeImg(true)">delete</span>
                            <img [src]="banner.imageDesktop">
                        </div>

                        <div class="text-info-upload">Tamanho recomendado: 1920 x 400 pixels</div>
                    </div>
                </div>
            </div>
            <div class="col-6 pr-5">
                <div class="container container-white" style="padding: 25px">
                    <div><span class="image-label">IMAGEM PARA MOBILE</span></div>
                    <div *ngIf="imgMobileUploadMessage" class="file-upload-status"
                        [ngClass]="{'warning-box': imgMobileUploadError, 'success-box': !imgMobileUploadError}">
                        <i class="material-icons" *ngIf="imgMobileUploadError">warning</i>
                        {{imgMobileUploadMessage}}
                    </div>
                    <div *ngIf="imgMobileUploader$ | async as uploader">
                        <div class="ng2FileDrop" ng2FileDrop [uploader]="uploader" *ngIf="!banner.imageMobile">
                            <i class="material-icons">file_upload</i>
                            <em>Arraste e solte as imagens aqui</em>
                            <span class="btn btn-outline-light">
                                <span>SELECIONAR ARQUIVOS</span>
                                <input type="file" id="imageUrl" ng2FileSelect [uploader]="uploader" multiple />
                            </span>
                            <small class="max-filesize">Tamanho máximo: 4MB</small>
                        </div>

                        <div class="ng2FileDrop container-upload-img" *ngIf="banner.imageMobile">
                            <span class="material-icons" style="font-size: 24px"
                                (click)="removeImg(false)">delete</span>
                            <img [src]="banner.imageMobile">
                        </div>
                        <div class="text-info-upload">Tamanho recomendado: 756 x 508 pixels</div>
                    </div>
                </div>
            </div>
            <div class="col-12 text-center mt-4">
                <a class="color-cool-grey underline" href="https://img.autoarremate.com.br/files/guia-banners.jpg"
                    download target="_blank">
                    Exemplo das medidas
                </a>
            </div>
        </div>
        <div class="row float-left mt-4">
            <button type="button" class="btn btn-primary btn-rounded text-center ml-2" (click)="saveBanner()">
                {{banner.id ? 'ATUALIZAR' : 'CADASTRAR'}}
            </button>
        </div>
    </div>
</div>